import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "menu", "actions", "mergeSubmit", "deleteSubmit"];

  connect() {
    this.pinSessionToken();
    this.escapeListClipping();
    this.setMode(false);
  }

  // The article list scrolls, and a scroll container clips anything absolutely
  // positioned inside it, so with only a few articles the action menu was cut
  // off. A fixed-position menu is laid out against the viewport instead, and the
  // viewport boundary keeps flip from measuring against the list and opening
  // the menu upwards.
  escapeListClipping() {
    this.menuTargets.forEach((menu) => {
      $(menu)
        .find('[data-toggle="dropdown"]')
        .dropdown({ boundary: "viewport", popperConfig: { positionFixed: true } });
    });
  }

  pinSessionToken() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const input = this.element.querySelector('input[name="authenticity_token"]');
    if (token && input) input.value = token;
  }

  enable() {
    this.setMode(true);
  }

  cancel() {
    this.setMode(false);
  }

  refresh() {
    const checked = this.checkboxTargets.filter((box) => box.checked);
    const hsCodeIds = checked.map((box) => box.dataset.hsCodeId);
    const mergeable = hsCodeIds.length >= 2 && hsCodeIds.every((id) => id === hsCodeIds[0]);

    this.mergeSubmitTarget.disabled = !mergeable;
    this.deleteSubmitTarget.disabled = checked.length < 1;
  }

  confirmDelete(event) {
    if (!window.confirm("Delete the selected articles?")) event.preventDefault();
  }

  setMode(on) {
    this.checkboxTargets.forEach((box) => {
      box.style.display = on ? "" : "none";
      if (!on) box.checked = false;
    });
    this.menuTargets.forEach((menu) => {
      menu.style.display = on ? "none" : "";
    });
    this.actionsTarget.style.display = on ? "" : "none";
    this.refresh();
  }
}
